import { Observable, Subject } from 'rxjs';

export class DialogRef<T> {
    private readonly afterClosedSubject$: Subject<T> = new Subject<T>();

    public afterClosed$: Observable<T> = this.afterClosedSubject$.asObservable();

    close(result?: T): void {
        if (typeof result !== 'undefined') {
            this.afterClosedSubject$.next(result);
        }

        this.afterClosedSubject$.complete(); // cleanup stream after it's closed
    }
}
